import React, { useEffect, useRef, useState } from 'react';
import { DetailWrapper, Header, InnerHeader, NavBar } from './BigNav.styles';
import { Buttons } from './Buttons';
import { Tabs } from './Tabs';
import { TabDetail } from './TabDetail';
import { Logo, ProgressBar } from '../shared';
import { AnalyticsAttributesProvider, useBreakpoints, useHeaderFooterContext } from '../../../components';
export function BigNav({ hasScrolled, isLoggedIn, model: { id, content: { goToBoardsText, logInText, progressBar, progressLabel, signUpText, startTransparent, tabs = [] } } }) {
    const [activeTab, setActiveTab] = useState();
    const { setHeaderHeight } = useHeaderFooterContext();
    const headerRef = useRef(null);
    const tabRef = useRef(null);
    const [detailHeight, setDetailHeight] = useState(0);
    const breakpoints = useBreakpoints();
    function escPress(event) {
        if (event.key === 'Escape') {
            setActiveTab(undefined);
        }
    }
    function handleResize() {
        if (headerRef.current && breakpoints.includes('lg')) {
            const height = headerRef.current.offsetHeight;
            setHeaderHeight(height);
        }
    }
    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [headerRef, isLoggedIn, setHeaderHeight, breakpoints]);
    useEffect(() => {
        const newHeight = tabRef.current ? tabRef.current.clientHeight : 0;
        setDetailHeight(newHeight);
        if (activeTab !== undefined) {
            window.addEventListener('keydown', escPress);
            document.body.classList.add('prevent-scroll');
        }
        return () => {
            window.removeEventListener('keydown', escPress);
            document.body.classList.remove('prevent-scroll');
        };
    }, [activeTab]);
    return (React.createElement(AnalyticsAttributesProvider, { value: { eventContainer: 'globalNav' } },
        React.createElement(Header, { "data-open": activeTab !== undefined, onClick: () => setActiveTab(undefined), "data-testid": "bignav" },
            React.createElement(InnerHeader, { "data-active": hasScrolled || activeTab !== undefined, startTransparent: startTransparent, onClick: (e) => e.stopPropagation() },
                React.createElement(NavBar, { ref: headerRef },
                    React.createElement(Logo, { id: id }),
                    tabs && (React.createElement(Tabs, { activeTab: activeTab, setActiveTab: setActiveTab, tabs: tabs })),
                    React.createElement(Buttons, { goToBoardsText: goToBoardsText, isLoggedIn: isLoggedIn, logInText: logInText, signUpText: signUpText, uuid: id }),
                    progressBar && React.createElement(ProgressBar, { progressLabel: progressLabel })),
                tabs.filter((tab) => tab.type === 'uiHeaderNavTab') && (React.createElement(DetailWrapper, { style: { height: detailHeight } }, tabs.map((tab, index) => tab.type === 'uiHeaderNavTab' && (React.createElement("div", { key: index, ref: activeTab === index ? tabRef : null, style: {
                        display: activeTab === index ? 'block' : 'none'
                    } },
                    React.createElement(TabDetail, { tab: tab, active: activeTab === index }))))))))));
}
//# sourceMappingURL=BigNav.js.map